module.exports = __webpack_public_path__ + "img/enterprise-road-1.4585b1fa.png";